<div class="widget-content-inner">
  <div class="col-12">
    <div class="sidebar-search">
      <form class="form-search" [formGroup]="searchBarForm">
        <button class="button-submit" type="submit">
          <i class="icon-search"></i>
        </button>
        <fieldset>
          <input type="text" placeholder="Search for a specific ticket" required [mask]="'00-00-00-00-00'"
            class="masked-input" formControlName="searchTicket">
        </fieldset>
      </form>
    </div>

    <div *ngIf="noTicketsFound" class="no-tickets-found">
      <div class="spacing"></div>
      Ticket not found
      <div class="spacing"></div>
    </div>
  </div>


  <div *ngIf="isMobile;else isNotMobile">
    <div *ngIf="!noTicketsFound" class="no-tickets-found">
      <div class="col-12">
        <app-lottery-results [results]="tickets" [columns]="columnsM" [pagination]="pagination"
          (pageChange)="onPageChange($event)" [isVotedFn]="isVoted.bind(this)" [onVoteFn]="onVote.bind(this)">
        </app-lottery-results>
      </div>
    </div>
  </div>

  <ng-template #isNotMobile>
    <div *ngIf="!noTicketsFound" class="no-tickets-found">
      <div class="col-12" style="max-width: 78rem;">
        <app-lottery-results [results]="tickets" [columns]="columns" [pagination]="pagination"
          (pageChange)="onPageChange($event)" [isVotedFn]="isVoted.bind(this)" [onVoteFn]="onVote.bind(this)">
        </app-lottery-results>
      </div>
    </div>
  </ng-template>



</div>